import Buttons from '@/component/popups/Buttons';
import PopupFrame from '@/component/popups/ui-1';
import { formatDataNumberToen } from '@/utils/helper';
import imgDontLoseYourStreak from '@assets/web-v3-images/icon-confirm.png';
import { Text } from '@radix-ui/themes';
import { useTranslation } from 'react-i18next';

export default function Confirm({
	open,
	onOpenChange,
	handleClick,
	selected = 0,
	balance = 0,
	disableOutsideClose,
	disabledPopup
}
) {
	const { t } = useTranslation()
	return (
		<PopupFrame
			open={open}
			onOpenChange={disabledPopup ? () => { } : onOpenChange}
			disableOutsideClose={disableOutsideClose}
			title={t("loyalty_point.confirm")}
			classNames='sm:!max-w-[600px]'
		>
			<div className=" flex flex-col items-center justify-center">

				<div className="flex justify-center px-10 sm:px-15 md:px-30 lg:px-30 xl:px-35 pt-5">
					<img
						src={imgDontLoseYourStreak}
						alt="turns"
						className="w-[120px] sm:w-[160px] md:w-[220px] lg:w-[220px] xl:w-[220px] h-auto"
					/>
				</div>
				<Text
					as="p"
					className="text-[#A15C07] font-medium text-[13px] sm:text-[19px] text-center pt-6 sm:px-5"
				>
					{t("loyalty_point.you_are_about_to_redeem_X_Mytel_Loyalty_Points")
						.replace("_LP1_", formatDataNumberToen(selected || ''))
						.replace("_LP2_", formatDataNumberToen(balance - selected))}
				</Text>

				<div className="flex gap-3 justify-between pt-5">
					<Buttons
						handleClick={() => onOpenChange(false)}
						textBtn={t("loyalty_point.cancel")}
						classItem="!m-0"
						classItemText='!text-[14px] sm:!text-[20px]'
						disabled={disabledPopup}
					/>
					<Buttons
						handleClick={handleClick}
						textBtn={t("loyalty_point.confirm")}
						classItem="!m-0"
						classItemText='!text-[14px] sm:!text-[20px]'
						disabled={disabledPopup}
					/>
				</div>
			</div>
		</PopupFrame>
	)
}
